import { Component, OnInit, Inject, Optional, Input } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LanguageService } from '../../shared/services/language.service';
import { ProjectTypesService } from '../../shared/services/project-types.service';
import { Profile } from 'src/app/models/Profile';
import {
  MAT_TOOLTIP_DEFAULT_OPTIONS,
  MatTooltipDefaultOptions,
  MatTooltipModule,
} from '@angular/material/tooltip';
import { InfoBarWithStatusService } from '../../shared/services/info-bar-with-status.service';

export const myCustomTooltipDefaults: MatTooltipDefaultOptions = {
  showDelay: 500,
  hideDelay: 500,
  touchendHideDelay: 500,
};

@Component({
  standalone: false,
  selector: 'app-macros-dialog',
  templateUrl: './macros-dialog.component.html',
  styleUrls: ['./macros-dialog.component.css'],
  providers: [{ provide: MAT_TOOLTIP_DEFAULT_OPTIONS, useValue: myCustomTooltipDefaults }],
})
export class MacrosDialogComponent implements OnInit {

  variables: any;

  //Temporary static items.
  items: any;

  local_data: any; //local data is the data that has been passed from the parent to this dialog and will be passed back to the parent.
  methodPredInvalid: boolean = false;
  effortInvalid: boolean = false;
  maxHoursInvalid: boolean = false;
  preMacroTypesInvalid: boolean = false;
  otherMacroNameInvalid: boolean = false;

  methodPredError: string = '';
  effortError: string = '';
  maxHoursError: string = '';
  preMacroTypesError: string = '';
  otherMacroNameError: string = '';


  isAction: boolean = false;
  isUsers: boolean = false;
  isSubTask: boolean = false;
  isProjectType: boolean = false;
  isConfigurationType: boolean = false;
  isMacroActivities: boolean = false;
  isMacroActivitiesType: boolean = false;
  filteredMacro: any[] = [];

  formGroup1: any;

  effort = '';

  otherType = false; //Flag to check if the user will add a custom input or use a predefined type.
  otherTypeMacro = false;

  riskInputEffort: any;

  isActionType: boolean = false;

  metod: any;
  item: any;
  list: any;
  listInDB: any;
  macrosListDeafult: any;
  macrosListInDB: any;

  isEdit = false;
  profiles: Profile[] = [];
  centers: string[] = [];
  filteredProfiles: Profile[] = [];
  itemIndex: number = 0;

  constructor(private projectTypesService: ProjectTypesService,
    public dialogRef: MatDialogRef<MacrosDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private _formBuilder: FormBuilder,
    private infoBar: InfoBarWithStatusService,
    private languageService: LanguageService
  ) {
    this.local_data = { ...data };
    this.items = [
      { name: this.variables?.implementation },
      { name: 'Review' },
      { name: this.variables?.other }
    ];
  }

  ngOnInit(): void {
    this.languageService.translations$.subscribe((vars: any) => {
      this.variables = vars;
    });


    this.isEdit = this.local_data.isEdit
    this.itemIndex = this.local_data.itemIndex;

    //Add default values to predefined list
    this.metod = this.local_data.metodology;
    this.item = this.local_data.item;
    this.list = this.local_data.list;
    this.listInDB = this.local_data.listInDB;
    this.profiles = Array.isArray(this.local_data.profiles) ? this.local_data.profiles : [];

    this.formGroup1 = this._formBuilder.group({
      methodPredCtrl: [{ 'value': this.metod, disabled: true }, Validators.required],
      effortCtrl: ['', [Validators.required, Validators.min(1), Validators.max(100)]],
      maxHoursCtrl: ['', [Validators.min(1)]],
      preMacroTypesCtrl: ['', Validators.required],
      otherTypeMacroCtrl: ['', Validators.required],
      profileCtrl: [''],
      centerCtrl: [''],
    });

    this.centers = [...new Set(this.profiles.map(p => p.center).filter(c => !!c))] as string[];
    this.filteredProfiles = this.profiles;

    if (this.local_data.effort) this.effort = this.local_data.effort;

    this.isAction = this.local_data.isAction !== undefined ? this.local_data.isAction : false;
    this.isActionType = this.local_data.isActionType !== undefined ? this.local_data.isActionType : false;
    this.isUsers = this.local_data.isUsers !== undefined ? this.local_data.isUsers : false;
    this.isSubTask = this.local_data.isSubTask !== undefined ? this.local_data.isSubTask : false;
    this.isProjectType = this.local_data.isProjectType !== undefined ? this.local_data.isProjectType : false;
    this.isConfigurationType = this.local_data.isConfigurationType !== undefined ? this.local_data.isConfigurationType : false;
    this.isMacroActivities = this.local_data.isMacroActivities !== undefined ? this.local_data.isMacroActivities : false;
    this.isMacroActivitiesType = this.local_data.isMacroActivitiesType !== undefined ? this.local_data.isMacroActivitiesType : false;




    if (this.isEdit) {
      if (this.metod !== "Agile" && this.metod !== "Waterfall") {
        this.otherType = true;

        this.onMethodSelectionChange(this.variables.other)
      }
      else {
        this.onMethodSelectionChange(this.metod)
      }
      if (this.otherType) {
        if (!this.searchMacroListByMacro(this.item.name)) {
          this.macrosListDeafult.push(
            {
              "name": this.item.name, "value": this.item.effort
            }
          )
        }
      }

      // fazer validacão nomes iguais
      this.formGroup1.get('effortCtrl')?.setValue(this.item.effort);
      this.formGroup1.get('preMacroTypesCtrl')?.setValue(this.item.name);
      this.formGroup1.get('maxHoursCtrl')?.setValue(this.item.maxHours || '');
      this.formGroup1.get('profileCtrl')?.setValue(this.item.profileId || '');
      const existingProfile = this.profiles.find(p => p.id === this.item.profileId);
      if (existingProfile?.center) {
        this.formGroup1.get('centerCtrl')?.setValue(existingProfile.center);
        this.filteredProfiles = this.profiles.filter(p => p.center === existingProfile.center);
      } else {
        this.filteredProfiles = this.profiles;
      }
    }
    else {
      if (this.metod !== "Agile" && this.metod !== "Waterfall") {
        this.otherType = true;

        this.onMethodSelectionChange(this.variables.other)
      }
      else {
        this.onMethodSelectionChange(this.metod)
      }
    }


    this.formGroup1.get("preMacroTypesCtrl").valueChanges.subscribe((result1: any) => {

      if (result1 === this.variables.other) {
        this.otherTypeMacro = true;
      }
      else this.otherTypeMacro = false;

      this.formGroup1.get('effortCtrl').setValue(this.searchMacroListByMacro(result1).value);

      if (result1.thirdtCtrl) this.effortInvalid = false;
      if (result1.preMacroTypesCtrl) this.preMacroTypesInvalid = false;
      if (result1.otherTypeMacroCtrl) this.otherMacroNameInvalid = false;
    });
  }


  onMethodSelectionChange(method: string) {
    this.macrosListDeafult = this.searchListByMethod(method).macro
  }

  searchListByMethod(methodName: any) {
    return this.list.find((item: any) => item.method === methodName
    );
  }

  searchMacroListByMacro(macroName: any) {
    return this.macrosListDeafult.find((item: any) => item.name === macroName);
  }


  onDBMethod() {
    this.macrosListInDB = this.listInDB.find((item: any) => item.metodology === this.metod).macroActivities
  }

  validateUniqueName(): boolean {
    this.onDBMethod();

    const nameToValidate = this.otherTypeMacro
      ? this.formGroup1.get('otherTypeMacroCtrl')?.value?.trim()
      : this.formGroup1.get('preMacroTypesCtrl')?.value?.trim();

    if (!nameToValidate) return true;

    const isUnique = !this.macrosListInDB.some((item: any) => {
      return item.name === nameToValidate;
    });

    return isUnique;
  }


  cleanErrors() {
    this.methodPredInvalid = false;
    this.effortInvalid = false;
    this.maxHoursInvalid = false;
    this.preMacroTypesInvalid = false;
    this.otherMacroNameInvalid = false;

    this.methodPredError = '';
    this.effortError = '';
    this.maxHoursError = '';
    this.preMacroTypesError = '';
    this.otherMacroNameError = '';
  }


  doAction() {
    const formGroup = this.formGroup1.value;
    let valid = true;
    this.cleanErrors()

    if (!this.formGroup1.valid) {

      /*
        Check if all the inputs have been filled.
      */

      if ((formGroup.preMacroTypesCtrl === '' || formGroup.preMacroTypesCtrl === undefined) && this.isMacroActivities && !this.isMacroActivitiesType) {
        this.preMacroTypesInvalid = true;
        this.preMacroTypesError = this.variables.selectMacroActivity;
        valid = false;
      }

      if ((formGroup.otherTypeMacroCtrl === '' || formGroup.otherTypeMacroCtrl === undefined) && this.otherTypeMacro) {
        this.otherMacroNameInvalid = true;
        this.otherMacroNameError = this.variables.insertName;
        valid = false;
      }
      if (formGroup.effortCtrl === '' || (formGroup.effortCtrl <= 0 || formGroup.effortCtrl > 100)) {
        this.effortInvalid = true;
        this.effortError = this.variables.numberBetweenZeroUndred;
        valid = false;
      }
    }


    if (!this.isEdit) {

      if (formGroup.otherTypeMacroCtrl?.trim()) {
        if (!this.validateUniqueName()) {
          this.otherMacroNameInvalid = true;
          this.otherMacroNameError = this.variables.snackBarErrorAddMacro;
          valid = false;
        }
      } else if (formGroup.preMacroTypesCtrl?.trim()) {
        if (!this.validateUniqueName()) {
          this.preMacroTypesInvalid = true;
          this.preMacroTypesError = this.variables.snackBarErrorAddMacro;
          valid = false;
        }
      }
    }

    if (formGroup.maxHoursCtrl !== '' && formGroup.maxHoursCtrl !== null && formGroup.maxHoursCtrl !== undefined && formGroup.maxHoursCtrl <= 0) {
      this.maxHoursInvalid = true;
      this.maxHoursError = this.variables.numberGreaterThenZero;
      valid = false;
    }

    this.local_data.effort = formGroup.effortCtrl;
    this.local_data.maxHours = formGroup.maxHoursCtrl !== '' && formGroup.maxHoursCtrl !== null ? parseFloat(formGroup.maxHoursCtrl) : null;
    this.local_data.macroActivities = formGroup.preMacroTypesCtrl !== this.variables.other ? formGroup.preMacroTypesCtrl : formGroup.otherTypeMacroCtrl
    this.local_data.profileId = formGroup.profileCtrl || null;

    //Pass data
    if (valid) {
      this.dialogRef.close({ data: this.local_data });
    }
    else {
      this.infoBar.showSnackbar(this.variables.errorInForm, ['error-snackbar'], 2000);
    }
  }

  onCenterChange(center: string): void {
    if (center) {
      this.filteredProfiles = this.profiles.filter(p => p.center === center);
    } else {
      this.filteredProfiles = this.profiles;
    }
    this.formGroup1.get('profileCtrl')?.setValue('');
  }
}
